const initialState = {}

export default function vendor(state = initialState, action) {
    switch (action.type) {
        case 'SET_VENDOR': {
            return Object.assign({}, action.data)
        }
        default: return state
    }
}